module.exports = __webpack_public_path__ + "img/2025-08-16e_3.d6f19bff.jpg";